module.exports = __webpack_public_path__ + "static/media/front_sided_power_btn_focus.7ea607ee.png";